/**
 * Auto-generated API Client
 *
 * Generated by @spfn/core codegen
 * DO NOT EDIT MANUALLY
 *
 * @generated 2025-11-03T13:40:07.037Z
 */

import { client } from '@spfn/core/client';
import type { InferContract } from '@spfn/core';

import { publishLabelContract } from '@/lib/contracts/labels';

// ============================================
// Types
// ============================================

export type PublishLabelResponse = InferContract<typeof publishLabelContract>['response'];
export type PublishLabelParams = InferContract<typeof publishLabelContract>['params'];
export type PublishLabelBody = InferContract<typeof publishLabelContract>['body'];

// ============================================
// API Functions
// ============================================

/**
 * POST /_cms/labels/:labelId/publish
 */
export const publishLabel = (options: { params: PublishLabelParams, body: PublishLabelBody }) => client.call(publishLabelContract, options);

